import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
export default function getBlockSendersConfirmTitleAndSubtext(emailAddresses) {
    return [title(emailAddresses), subtext(emailAddresses)];
}
function title(emailAddresses) {
    return formatSenders(emailAddresses, function (e) { return e.Name; }, strings.blockSendersTitle, strings.blockTwoSendersTitle, strings.blockThreeSendersTitle, strings.blockFourToSixSendersTitle, strings.blockSevenOrMoreSendersTitle);
}
function subtext(emailAddresses) {
    return formatSenders(emailAddresses, function (e) { return e.EmailAddress; }, strings.blockSendersSubtext, strings.blockTwoSendersSubtext, strings.blockThreeSendersSubtext, strings.blockFourToSixSendersSubtext, strings.blockSevenOrMoreSendersSubtext);
}
function formatSenders(emailAddresses, toText, oneSender, twoSenders, threeSenders, fourToSixSenders, sevenOrMoreSenders) {
    switch (emailAddresses.length) {
        case 0:
            throw new Error('formatSenders: no email addresses');
        case 1:
            return format(oneSender, toText(emailAddresses[0]));
        case 2:
            return format(twoSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 3:
            return format(threeSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 4:
        case 5:
        case 6:
            return format(fourToSixSenders, toText(emailAddresses[0]), toText(emailAddresses[1]), emailAddresses.length - 2);
        default:
            return format(sevenOrMoreSenders, toText(emailAddresses[0]), toText(emailAddresses[1]), emailAddresses.length - 2);
    }
}
//# sourceMappingURL=getBlockSendersConfirmTitleAndSubtext.js.map